import React, { useState } from 'react';
import { Card, Tabs, Alert } from 'antd';
import { FormOutlined, CloudUploadOutlined, ScanOutlined } from '@ant-design/icons';
import BPForm from '@/components/forms/BPForm';
import BSForm from '@/components/forms/BSForm';
import LarkImport from '@/components/forms/LarkImport';
import OCRUpload from '@/components/forms/OCRUpload';

const DataInput: React.FC = () => {
  const [activeKey, setActiveKey] = useState('bp');

  const items = [
    {
      key: 'bp',
      label: (
        <span>
          <FormOutlined style={{ marginRight: 4 }} />
          血压录入
        </span>
      ),
      children: <BPForm onSuccess={() => setActiveKey('bs')} />
    },
    {
      key: 'bs',
      label: (
        <span>
          <FormOutlined style={{ marginRight: 4 }} />
          血糖录入
        </span>
      ),
      children: <BSForm onSuccess={() => setActiveKey('lark')} />
    },
    {
      key: 'lark',
      label: (
        <span>
          <CloudUploadOutlined style={{ marginRight: 4 }} />
          飞书导入
        </span>
      ),
      children: <LarkImport onSuccess={() => setActiveKey('ocr')} />
    },
    {
      key: 'ocr',
      label: (
        <span>
          <ScanOutlined style={{ marginRight: 4 }} />
          OCR识别
        </span>
      ),
      children: <OCRUpload />
    }
  ];

  return (
    <div style={{ padding: 24 }}>
      <h1 style={{ marginBottom: 24 }}>
        <FormOutlined style={{ marginRight: 8 }} />
        数据录入
      </h1>

      <Alert
        message="多种数据录入方式"
        description="支持手动录入、飞书聊天记录批量导入、以及OCR识别体检报告"
        type="info"
        showIcon
        style={{ marginBottom: 24 }}
      />

      <Card>
        <Tabs
          activeKey={activeKey}
          onChange={setActiveKey}
          items={items}
          type="card"
        />
      </Card>
    </div>
  );
};

export default DataInput;
